import { FormBuilder, FormGroup } from '@angular/forms';
import { TemporalState } from 'src/app/core/models/api/sane-project/arpa-model';
import {
  accidentPresets,
  CalculatorProductViewModel,
  deathsPresets,
  dependencePresets,
  itPresets,
  lifePresets,
  wholeLifePresets
} from '../sane-project-calculator/models/calculator-product.viewmodel';
import { EditViewModel } from '../sane-project-edit/models/sane-project-edit.viewmodel';

export class ProjectViewModel {
  form: FormGroup;
  temporalState: TemporalState;
  edit: EditViewModel;

  calculatorLife: {
    allianz: CalculatorProductViewModel;
    axa: CalculatorProductViewModel;
    staLucia: CalculatorProductViewModel;
    surne: CalculatorProductViewModel;
    surneLifePro: CalculatorProductViewModel;
    helvetia: CalculatorProductViewModel;
    prebal: CalculatorProductViewModel;
    prebalInvPro: CalculatorProductViewModel;
    zurich: CalculatorProductViewModel;
  };

  calculatorAccidents: {
    axa: CalculatorProductViewModel;
    surne: CalculatorProductViewModel;
    prebal: CalculatorProductViewModel;
  };

  calculatorIT: {
    pmElite: CalculatorProductViewModel;
    pmCoeg: CalculatorProductViewModel;
    surnePlus: CalculatorProductViewModel;
    surneVip: CalculatorProductViewModel;
    prebal: CalculatorProductViewModel;
  };

  calculatorDependence: {
    axa: CalculatorProductViewModel;
    surne: CalculatorProductViewModel;
  };

  calculatorLifeWhole: {
    staLucia: CalculatorProductViewModel;
  };

  calculatorDeaths: {
    aura: CalculatorProductViewModel;
  };

  constructor(fb: FormBuilder) {
    this.temporalState = TemporalState.Inactive;
    this.edit = new EditViewModel(fb);

    this.calculatorLife = {
      allianz: new CalculatorProductViewModel(lifePresets['allianz']),
      axa: new CalculatorProductViewModel(lifePresets['axa']),
      staLucia: new CalculatorProductViewModel(lifePresets['staLucia']),
      surne: new CalculatorProductViewModel(lifePresets['surne']),
      surneLifePro: new CalculatorProductViewModel(lifePresets['surneLifePro']),
      helvetia: new CalculatorProductViewModel(lifePresets['helvetia']),
      prebal: new CalculatorProductViewModel(lifePresets['prebal']),
      prebalInvPro: new CalculatorProductViewModel(lifePresets['prebalInvPro']),
      zurich: new CalculatorProductViewModel(lifePresets['zurich'])
    };

    this.calculatorAccidents = {
      axa: new CalculatorProductViewModel(accidentPresets['axa']),
      surne: new CalculatorProductViewModel(accidentPresets['surne']),
      prebal: new CalculatorProductViewModel(accidentPresets['prebal'])
    };

    this.calculatorIT = {
      pmElite: new CalculatorProductViewModel(itPresets['pmElite']),
      pmCoeg: new CalculatorProductViewModel(itPresets['pmCoeg']),
      surnePlus: new CalculatorProductViewModel(itPresets['surnePlus']),
      surneVip: new CalculatorProductViewModel(itPresets['surneVip']),
      prebal: new CalculatorProductViewModel(itPresets['prebal'])
    };

    this.calculatorDependence = {
      axa: new CalculatorProductViewModel(dependencePresets['axa']),
      surne: new CalculatorProductViewModel(dependencePresets['surne'])
    };

    this.calculatorLifeWhole = {
      staLucia: new CalculatorProductViewModel(wholeLifePresets['staLucia'])
    };

    this.calculatorDeaths = {
      aura: new CalculatorProductViewModel(deathsPresets['aura'])
    };

    this.form = fb.group({
      temporalState: [this.temporalState],
      edit: this.edit.editForm,
      calculatorLife: fb.group({
        allianz: this.calculatorLife.allianz.form,
        axa: this.calculatorLife.axa.form,
        staLucia: this.calculatorLife.staLucia.form,
        surne: this.calculatorLife.surne.form,
        surneLifePro: this.calculatorLife.surneLifePro.form,
        helvetia: this.calculatorLife.helvetia.form,
        prebal: this.calculatorLife.prebal.form,
        prebalInvPro: this.calculatorLife.prebalInvPro.form,
        zurich: this.calculatorLife.zurich.form
      }),
      calculatorAccidents: fb.group({
        axa: this.calculatorAccidents.axa.form,
        surne: this.calculatorAccidents.surne.form,
        prebal: this.calculatorAccidents.prebal.form
      }),
      calculatorIT: fb.group({
        pmElite: this.calculatorIT.pmElite.form,
        pmCoeg: this.calculatorIT.pmCoeg.form,
        surnePlus: this.calculatorIT.surnePlus.form,
        surneVip: this.calculatorIT.surneVip.form,
        prebal: this.calculatorIT.prebal.form
      }),
      calculatorDependence: fb.group({
        axa: this.calculatorDependence.axa.form,
        surne: this.calculatorDependence.surne.form
      }),
      calculatorLifeWhole: fb.group({
        staLucia: this.calculatorLifeWhole.staLucia.form
      }),
      calculatorDeaths: fb.group({
        aura: this.calculatorDeaths.aura.form
      })
    });
  }

  public get totalBonus(): number {
    const allCalculators = [
      ...Object.values(this.calculatorLife),
      ...Object.values(this.calculatorAccidents),
      ...Object.values(this.calculatorIT),
      ...Object.values(this.calculatorDependence),
      ...Object.values(this.calculatorLifeWhole),
      ...Object.values(this.calculatorDeaths)
    ];
    return allCalculators.reduce((sum, vm) => sum + (vm.bonus ?? 0), 0);
  }
}
